import { Attachment, RockLanguage, TeamListModel, UserListModel } from '@ninety/mobile/platform/api';

import { RockQuarter } from './rock-request.model';
import { RockStatusCode } from './status-code';

export type RockQuarterSelection = `${RockQuarter}-${number}`;

export interface CreateRockForm {
  title: string;
  description: string;
  teamId: string;
  dueDate: string;
  userId: string;
  additionalTeamIds: string[];
  statusCode: RockStatusCode;
  attachments: Array<Attachment>;
  companyId: string;
  isDepartmentalRock: boolean;
  isCompanyRock: boolean;
  quarter: RockQuarterSelection;
  rockQuarterYearDueDate: Date;
}

export const InitialFormValues: CreateRockForm = {
  description: '',
  dueDate: new Date().toISOString(),

  statusCode: RockStatusCode.onTrack,
  teamId: '',
  title: '',
  userId: '',
  attachments: [],
  companyId: '',
  additionalTeamIds: [],
  isDepartmentalRock: false,
  isCompanyRock: false,
  quarter: `${RockQuarter.none}-${new Date().getFullYear()}` as RockQuarterSelection,
  rockQuarterYearDueDate: new Date(),
};

export interface CreateRockVm {
  isValid: boolean;
  language: RockLanguage;
  dateFormatOptions: { date: Intl.DateTimeFormatOptions };
  dateMax: string;
  rockStatusDisplayOptions: {
    iconSrc: string;
    className: string;
    statusCode: RockStatusCode;
    displayValue: string;
  }[];
  showDepartmentalRock: boolean;
  showCompanyAndDepartmentalRock: boolean;
  userCanEditRockLevelCode: boolean;
  teams: TeamListModel[];
  users: UserListModel[];
  isSubmitted: boolean;
  rockQuarterOptions: { quarter: RockQuarter; year: number; rockQuarterYearDueDate: Date }[];
}
